import { isDesktop } from '../../lib/platform.ts'

/**
 * Eventos que o shell desktop (Rust) manda para o app web — sem
 * `@tauri-apps/api`, pela mesma ponte `__TAURI_INTERNALS__` das aplicações
 * (ver desktop.ts). No navegador não há ponte e o `escutar` é um no-op.
 *
 * Usado pelos avisos do chat (SPEC-20260916-1256): o toast do Windows devolve
 * a resposta rápida e o clique de "abrir a conversa" por aqui.
 */

type Invoke = (comando: string, argumentos?: Record<string, unknown>) => Promise<unknown>
type Internos = {
  invoke?: Invoke
  transformCallback?: (callback: (payload: unknown) => void, once?: boolean) => number
}

function internos(): Internos | null {
  if (!isDesktop()) return null
  const w = window as unknown as { __TAURI_INTERNALS__?: Internos }
  return w.__TAURI_INTERNALS__ ?? null
}

/**
 * Escuta um evento do shell. Devolve a função que para de escutar.
 * O payload chega já desembrulhado (só o que o Rust emitiu).
 */
export function escutarDoDesktop<T>(evento: string, aoReceber: (payload: T) => void): () => void {
  const i = internos()
  if (!i?.invoke || !i.transformCallback) return () => undefined
  const invoke = i.invoke
  let idDaEscuta: number | null = null
  let parado = false
  const handler = i.transformCallback((bruto: unknown) => {
    const env = bruto as { payload?: T } | null
    if (env && 'payload' in env) aoReceber(env.payload as T)
  })
  void invoke('plugin:event|listen', { event: evento, target: { kind: 'Any' }, handler })
    .then((id) => {
      if (parado) void invoke('plugin:event|unlisten', { event: evento, eventId: id })
      else idDaEscuta = id as number
    })
    .catch(() => undefined)
  return () => {
    parado = true
    if (idDaEscuta !== null) void invoke('plugin:event|unlisten', { event: evento, eventId: idDaEscuta }).catch(() => undefined)
  }
}
